/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */

import React, { Ref, useCallback, useEffect, useRef, useState } from "react";
import DropZone from "./views/dropzone";
import { serviceContainerType } from "./types";
import { downloadImage } from "../../helpers/imageHelper";
import validatorHelper, {
  validateCropDimention,
} from "../../helpers/validatorHelper";
import { setImageData } from "./utils/helpers";

import ClearBtn from "./views/clear-btn";

import Tools from "./views/tools";

import Preview from "./views/preview";

import AnalyticsSender from "../../helpers/analyticsSender";
import content from "./content";

import { acceptImageTypes } from "./utils/constants";
import { useDispatch } from "react-redux";
import {
  clearError,
  setImage,
  setError,
  setDimension,
  showPopup,
  setFlipVertical,
  setFlipHorizontal,
  setChanged,
  setCropProportions,
  setCropDimensions,
  setCropValidation,
  setCropPosition,
  canvasSetRotationAngle,
  clearRotatePosition,
  canvasSetDimension,
  resizeSetSaveProportions,
  resizeSetFormat
} from "./redux/action";

import * as analytics from "./analytics";

import canvasActions from "../../redux/actions/canvasActions";
import imageActions from "../../redux/actions/imageActions";
import popupActions from "../../redux/actions/popupActions";
import previewActions from "../../redux/actions/previewActions";
import validatorActions from "../../redux/actions/validatorActions";
import Actions from "./views/actions";
import { canvasFlip, canvasResize, canvasRotate, createImage } from '../../helpers/canvasHelpers';

import { TOOLS_LIST, TOOLS_DESCRIPTION } from "./constants";
import selectors from "./redux/selectors";
import Control from "./views/controls";
import { clickDownloadHandler, clickResetHandler, showClearPopup, clickCropHandler } from "./utils/service";
import { clearAll } from "../../helpers/siteHeplers";

const Service = ({ service, uploadElement }: serviceContainerType) => {
  //ToDoRemove
  const { imageClear } = imageActions();
  const {
    canvasRotationAngle,
    canvasFormat,
    canvasWidth,
    canvasHeight,
    canvasClear,
    changeImage,
  } = canvasActions();

  const { setWarningWidth, setWarningHeight } = validatorActions();

  const dispatch = useDispatch();
  const { validateFormatFile } = validatorHelper();

  const dataContent = content(service);
  const analyticsSender = new AnalyticsSender();

  const [canvasInputValue, setCanvasInputValue] = useState({
    width: 0,
    height: 0,
  });

  const [resizeIsOpenSelect, resizeSetOpenSelect] = useState(false);

  const canvasRef = useRef(null);
  const canvasCropperRef = useRef(null);

  const {
    image,
    imageName,
    isFlipHorizontal,
    canvasImage,
    canvasType,
    canvasIsChanged,
    imageWidth,
    imageHeight,
    cropIsSaveProportions,
    error,
    cropValidation,
    cropDimensions,
    cropPosition,
    isFlipVertical,
    warningWidth,
    warningHeight,
    resizeIsSaveProportion,
    imageFormat
  } = selectors();

  useEffect(() => {
    if (service === "cropper") {
      if ((cropDimensions.width === 0, cropDimensions.height === 0)) {
        dispatch(
          setCropDimensions(
            Math.round(imageWidth * 0.9),
            Math.round(imageHeight * 0.9)
          )
        );

        setCanvasInputValue({
          width: Math.round(imageWidth * 0.9),
          height: Math.round(imageHeight * 0.9),
        });
      }
    }
  }, [image, imageWidth, imageHeight]);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (error) dispatch(clearError());

    if (validateFormatFile(acceptedFiles)) {
      const file = acceptedFiles.pop();

      setImageData(
        file,
        service,
        analyticsSender.sendErrorSizeImage,
        analyticsSender.sendAddError,
        analyticsSender.sendAddImage,
        setImage,
        setDimension,
        setError,
        dispatch
      );

      createImage(URL.createObjectURL(file)).then((image) => {
        if (canvasRef.current) {
          const context = canvasRef.current.getContext("2d");
          context.drawImage(image, 0, 0);

          changeImage(canvasRef.current.toDataURL(canvasFormat));
        }
      });
    } else {
      analytics.sendAddError("not_valid_format");
      dispatch(setError("notValidFomat"));
    }
  }, []);
 

  //Crop
  const cropSetIsSaveProportions = (isSaveProportions) => {
    dispatch(setCropProportions(isSaveProportions));
  };

  const cropSetDimensions = (width: number, height: number) => {
    let inputWidthValue = isNaN(width) || width === Infinity ? 1 : width;
    let inputHeightValue = isNaN(height) || height === Infinity ? 1 : height;

    if (cropIsSaveProportions) {
      const proportionInputWidthValue = Math.ceil(
        inputWidthValue / (canvasInputValue.height / inputHeightValue)
      );

      const proportionInputHeightValue = Math.ceil(
        inputHeightValue / (canvasInputValue.width / inputWidthValue)
      );

      inputWidthValue =
        isNaN(proportionInputWidthValue) ||
        proportionInputWidthValue === Infinity
          ? inputWidthValue === 0 && inputHeightValue !== 0
            ? inputHeightValue
            : inputWidthValue
          : proportionInputWidthValue;

      inputHeightValue =
        isNaN(proportionInputHeightValue) ||
        proportionInputHeightValue === Infinity
          ? inputWidthValue !== 0 && inputHeightValue === 0
            ? inputWidthValue
            : inputHeightValue
          : proportionInputHeightValue;
    }

    analyticsSender.sendChangeDimensiom(
      inputWidthValue,
      inputHeightValue,
      width !== cropDimensions.width ? "width" : "height"
    );

    setCanvasInputValue({ width: inputWidthValue, height: inputHeightValue });

    const validation = validateCropDimention(
      canvasWidth,
      canvasHeight,
      inputWidthValue,
      inputHeightValue
    );

    dispatch(setCropValidation(validation));

    if (validation.isValid) {
      if (cropPosition.x + inputWidthValue > canvasWidth) {
        dispatch(
          setCropPosition(
            cropPosition.x -
              (canvasWidth - (cropPosition.x + inputWidthValue)) * -1,
            cropPosition.y
          )
        );
      }

      if (cropPosition.y + inputHeightValue > canvasHeight) {
        dispatch(
          setCropPosition(
            cropPosition.x,
            cropPosition.y -
              (canvasHeight - (cropPosition.y + inputHeightValue)) * -1
          )
        );
      }

      dispatch(setCropDimensions(inputWidthValue, inputHeightValue));
    } else {
      analyticsSender.sendErrorChangeDimensiom(
        inputWidthValue,
        inputHeightValue,
        validation.input
      );
    }
  };

  const editImage = (imageFile, context, service) => {
		
		switch (service) {
		case 'resizer':
			return canvasResize(imageFile, context, canvasWidth, canvasHeight);
		case 'rotator':
			return canvasRotate(
				imageFile, context, canvasWidth, canvasHeight, 
				imageWidth, imageHeight, canvasRotationAngle
			);
		case 'flipper':
			return canvasFlip(
				imageFile, context, canvasWidth, canvasHeight, imageWidth, 
				imageHeight, isFlipVertical, isFlipHorizontal
			);
		default: 
			return canvasResize(imageFile, context, canvasWidth, canvasHeight);
		}
	};

  return (
    <div className="service">
 
        <DropZone
          uploadElement={uploadElement}
          service={service}
          content={dataContent}
          acceptImageTypes={acceptImageTypes.map((type) => `.${type.name}`)}
          onDrop={onDrop}
          error={error}
          analytics={analytics}
          image={image}
        />
      
        <Preview
          service={service}
          image={image}
          canvasIsChanged={canvasIsChanged}
          imageWidth={imageWidth}
          imageHeight={imageHeight}
          cropDimensions={
            cropDimensions
              ? cropDimensions
              : {
                  width: imageWidth * 0.9,
                  height: imageHeight * 0.9,
                }
          }
          canvasDimension={{width: canvasWidth, height: canvasHeight}}
          showClearPopup={showClearPopup}
          clearAll={clearAll}
          setCropDimensions={setCropDimensions}
          dispatch={dispatch}
          cropIsSaveProportions={cropIsSaveProportions}
          cropPosition={cropPosition}
          setCropPosition={setCropPosition}
          canvasRef={canvasRef}
          canvasCropperRef={canvasCropperRef}
          setChange={setChanged}
          setCanvasInputValue={setCanvasInputValue}
          editImage={editImage}
          canvasRotationAngle={canvasRotationAngle}
          isFlipVertical={isFlipVertical}
          isFlipHorizontal={isFlipHorizontal}
          canvasFormat={canvasFormat}
          getCanvasImage={createImage} 
          changeImage={changeImage} 
          analytics={analytics}
          showPopup={showPopup}
        />
      
      <Tools tools={TOOLS_LIST} description={TOOLS_DESCRIPTION} analytics={analytics} service={service} isAddedImage={!!image} />
      <div className="service__control">
        <ClearBtn
          isAddedImage={!!image}
          canvasIsChanged={canvasIsChanged}
          helpers={true}
          isWhite={false}
          showClearPopup={showClearPopup}
          clearAll={clearAll} 
          showPopup={showPopup} 
          sendShowRemovePopup={analytics.sendShowRemovePopup} 
          dispatch={dispatch}
        />

        <span className="service__control-title">
          {dataContent.titleService}
        </span>
       
        <Control
          service={service}
          image={image}

          imageHeight={imageHeight}
          imageWidth={imageWidth}
          analytics={analytics}
          dispatch={dispatch}
          setChanged={setChanged}

          //Cropper
          cropDimensions={canvasInputValue}
          cropIsSaveProportions={cropIsSaveProportions}
          cropValidation={cropValidation}
          cropSetIsSaveProportions={cropSetIsSaveProportions}
          cropSetDimensions={cropSetDimensions}
          
          //EndCropper
         
          //Flipper
          isFlipVertical={isFlipVertical}
          isFlipHorizontal={isFlipHorizontal}
          setFlipVertical={setFlipVertical}
          setFlipHorizontal={setFlipHorizontal}
          //End Flipper
         
          //Rotated
          previewClearPosition={clearRotatePosition}
          canvasRotationAngle={canvasRotationAngle}
          canvasDimensionWidth={canvasWidth}
          canvasDimensionHeight={canvasHeight}
          canvasSetRotationAngle={canvasSetRotationAngle}
          canvasSetDimension={canvasSetDimension}
          //End Rotated
          
          //Resizer
          resizeCanvasFormat={canvasFormat}
          resizeIsSaveProportion={resizeIsSaveProportion}
          resizeSetSaveProportions={resizeSetSaveProportions}
          resizeIsOpenSelect={resizeIsOpenSelect}
          resizeSetOpenSelect={resizeSetOpenSelect}
          resizeSetFormat={resizeSetFormat}
          //End Resizer
          
          warningWidth={warningWidth}
          warningHeight={warningHeight}
          setWarningWidth={setWarningWidth}
          setWarningHeight={setWarningHeight}
          setDimensionsetChanged={undefined} 
/>

        <Actions
          service={service}
          property={{
            image: canvasImage,
            imageType: canvasType,
            imageName: imageName,
            cropPosition: cropPosition,
            cropDimensions: cropDimensions,
            analyticsInfo: {
              rotate: canvasRotationAngle,
              widthIn: imageWidth,
              heightIn: imageHeight,
              widthOut: canvasWidth,
              heightOut: canvasHeight,
              isFlipVertical: isFlipVertical,
              isFlipHorizontal: isFlipHorizontal,
              formatIn: imageFormat,
              formatOut: canvasType
            }
          }}
          clickDownloadHandler={clickDownloadHandler}
          clickResetHandler={clickResetHandler}
          clickCropHandler={clickCropHandler}
          sendDownloadEvent={analytics.sendDownloadEvent}
          downloadImage={downloadImage}
          dispatch={dispatch}
          

          setCanvasDimensions={canvasSetDimension}
          setCropDimensions={setCropDimensions}
          setCanvasInputValue={setCanvasInputValue}
          setCropValidation={setCropValidation}
          setCropPosition={setCropPosition}
          sendClickResset={analytics.sendClickReset} 
          canvasRef={canvasRef} 
          getCanvasImage={createImage} 
          changeImage={changeImage} 
          sendClickCrop={analytics.sendClickCrop} />
      </div>
    </div>
  );
};

export default Service;
